import React from "react"
import { graphql, useStaticQuery } from "gatsby";
import {
  Link,
  Trans,
  useTranslation,
  useI18next,
  I18nextContext
} from "gatsby-plugin-react-i18next"

import { Link as ScrollToLink } from 'react-scroll'
import scrollToElement from 'scroll-to-element';

import { Helmet } from "react-helmet";
import SEO from "../components/seo";
import Layout from "../components/layout";

import { Content, ContentInner} from '../styles/global-styles';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import SimpleCard from '../components/our-model-mini-card'

import Box from '@material-ui/core/Box';

import styled from "styled-components";

import SectionHeader from '../components/section-header';

import ourModelsBackground from '../images/background-our-models.jpg'


const Container = styled.div`
    width: 100%;
    text-align: center;
    margin: 0 auto;
    margin-top: -131px;
    padding-top: 131px;
    background-color: #20466b;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23204666' stroke-width='.5' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cuse fill='%23244a69' href='%23s' y='2'/%3E%3Cuse fill='%23244a69' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23294d6c' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23294d6c' href='%23s'/%3E%3Cuse fill='%232d516f' href='%23s' x='2'/%3E%3Cuse fill='%232d516f' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23325572'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23325572'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23365975'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23204666'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%233b5c78'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23eaf1f3'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23eaf1f3'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23eaf1f3'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");

    background-image: url(${(props)=>props.backgroundImage});
    background-attachment: fixed;
    background-size: cover;
    background-repeat: no-repeat;
`


const ContentWrapper = styled.div`
    margin: 0 auto;
    text-align: center;
    background-color: ${props=>props.$backgroundColour};
    color: ${props=>props.$colour};
    padding-top: 60px;
    padding-bottom: 60px;
`

const StyledContentInner = styled(ContentInner)`
    a {
        color: #ff8000;
    }
    
    @media screen and (max-width: 767px) {
        width: 95%;
        
        img {
            width: 100%;
        }
    }
`

const StyledContent = styled(Content)`
    p {
        text-align: justify;
    }
    
    img {
        display: block;
        margin: auto;
    }
`

const useStyles = makeStyles((theme) =>
  createStyles({
    cardContainer: {
      	display: 'flex',
	    gap: '1em',
	    flexWrap: 'wrap',
	    justifyContent: 'center',
	    cursor: 'pointer',
	    '& > *': {
    		// flexBasis: 275,
    		flexBasis: 230,
    		minWidth: '15em',
    		backgroundColor: 'wheat',
    		['@media screen and (max-width: 575px)']: {
    		        width: '95%',
    		        minWidth: 'initial',
    		        flexBasis: 'auto',
            },
            
            '& .card-title': {
                // height: 64,
                height: 96,

                ['@media screen and (max-width: 1340px)']: {
    		        height: 64,
                },
            },
            
            '& .card-text': {
                fontSize: 19,
            },
    		
    		'&:hover': {
    		     '& > *': {
    		    backgroundColor: 'rgb(44,70,107)',
    		    // color: 'wheat',
    		    transition: 'background 0.3s ease',
    		    
    		    '& .card-title': {
    		         
                        color: 'wheat',
    		    },
    		    
    		    '& .card-button': {
    		        color: 'white'
    		    },
    		    
    		    '& .card-text': {
                    color: 'white',
    		    },
    		    
    		    '& .card-title-link': {
        		    '&:hover': {
        		       
        		         '& .card-title': {
        		         
        		            color: 'wheat',
        		            '-webkit-text-stroke': '0',
                            '-webkit-text-stroke-color': 'wheat',
                                '-webkit-text-stroke-width': '0',
        		       
        		        },
        		        
        		    }
    		    },
    		    '& a': {
    		        '&:hover': {
    		            color: 'white',
    		            '-webkit-text-stroke': '0',
                        '-webkit-text-stroke-color': 'wheat',
                        '-webkit-text-stroke-width': '0',
    		        }     
    		  },
    		}
    		
	    },
	    'h2': {
            height: "64px!important",
            // height: "96px!important",
	    }
    }},
    cardTitle: {
        fontSize: 28,
        textTransform: 'uppercase',
        marginBottom: 32,
    },
    
    radio: {
        position: 'fixed',
        bottom: 0,
        left: 2,
        zIndex: 1000000,
    }
    

  }),
);





export const query = graphql`
    query ($slug: String!) {
        markdownRemark ( fields: { slug: { eq: $slug } } ) {
            frontmatter {
              title
              language
              category
            }
            html
        }
        
    }
`


const OurModelsTemplate = (props) => {
    
    const { 
      title, 
      language,
      category
    } = props.data.markdownRemark.frontmatter
    
    const { html } = props.data.markdownRemark
    
    React.useEffect(()=>{
        console.log(props)
    }, [])
    
    
    const classes = useStyles();
    
    const context = React.useContext(I18nextContext);
    const currentLanguage = context.language;
    const {t} = useI18next();
    

    const models = props.pathContext.models
    let modelsFilteredByLanguage = models.filter(model=>model.node.frontmatter.language === currentLanguage)
    
    return (
      <Layout>
        <SEO title={title} />
        
            <Container backgroundImage={ourModelsBackground}>
            <Helmet>
                <script type="text/javascript" src="https://viewer.diagrams.net/js/viewer-static.min.js"></script>
            </Helmet>
            
                <ContentWrapper >
                    <SectionHeader id="section-header" title={title} colour={"white"}  withBackground={false}/>
                    <StyledContent>
                        <StyledContentInner className="justify">
                            <div dangerouslySetInnerHTML={{__html: html}} />
                        </StyledContentInner>
                    </StyledContent>
                    <Content className="reduced-margin-top">

                        <h3 className={classes.cardTitle}>{t("OUR-MODEL.MORE-MODELS")}</h3>
                        <Box className={classes.cardContainer}>
                            {
                                modelsFilteredByLanguage.map((model, index)=>{
                                    if (model.node.frontmatter.title !== title) {
                                        return (
                                            <SimpleCard key={model.node.frontmatter.title} cardNumber={`${index}`} link={model.node.fields.langrefpath} title={model.node.frontmatter.title} body={model.node.frontmatter.excerpt}/>
                                        )
                                    }
                                })
                            }
                        </Box>
                      
                    </Content>
                </ContentWrapper>
            </Container>
      </Layout>
    )
}

export default OurModelsTemplate

